import React from "react";
import { useContext } from "react";
import Login from "../../pages/Login";
import { AuthContext } from "./AuthContext";
import { staffCanAccessMenu } from "../../config/menuAccessCatalog";

/**
 * Protege rotas do painel.
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {"all"} [props.permition] — "all" libera sem checar menu (ex.: home)
 * @param {string[]} [props.permition] — legado: lista de níveis permitidos
 * @param {string} [props.menu] — id do catálogo em menuAccessCatalog (preferencial)
 */
export const RequireAuth = ({ children, permition, menu }) => {
  const { user } = useContext(AuthContext);
  if (permition === "all") {
    return children;
  }
  if (!user) {
    return <Login />;
  }
  if (menu) {
    if (!staffCanAccessMenu(user, menu)) {
      return <Login />;
    }
    return children;
  }
  if (!permition || !permition.includes(user.level)) {
    return <Login />;
  }
  return children;
};
